import actions from "./actions";

const {
	SET_DATA_PENDING_PRODUCTS,
	GET_DATA_BEGIN,
	GET_DATA_FINISH,
} = actions;

const initialState = {
	list: [],
	loading: false,
	totalItems: 0,
	currentPage: 1,
};

const pendingProductsReducer = (state = initialState, action: any) => {
       const { type, data } = action;
       switch (type) {
	       case GET_DATA_BEGIN:
		       return {
			       ...state,
			       loading: true,
		       };
	       case SET_DATA_PENDING_PRODUCTS:
		       return {
			       ...state,
			       list: Array.isArray(data && data.list) ? data.list : [],
			       totalItems: typeof data?.totalItems === 'number' ? data.totalItems : 0,
			       currentPage: typeof data?.currentPage === 'number' ? data.currentPage : 1,
			       loading: false,
		       };
	       case GET_DATA_FINISH:
		       return {
			       ...state,
			       loading: false,
		       };
	       default:
		       return state;
       }
};

export { pendingProductsReducer };